<template>
    <div class="right-bar__ruler help">
        <h3 class="right-bar__header">{{ $t('translation.help') }}</h3>

        <div class="col">
            <h4 class="help__header">{{ $t('translation.siteMessage') }}</h4>

            <div class="help__body">
                <iframe
                    class="help__iframe"
                    name="help-iframe"
                    id="help-iframe"
                    :src="`${webAppUrl}/static/help/${authCurrentLang}.html`"
                >
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import authMixin from '../../../mixins/auth';

    export default {
        mixins: [
            authMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// src/components/Code/rightbar/Help.vue